import { gql } from '__generated__';

export const UPDATE_USER_SETTINGS = gql(/* GraphQL */ `
  mutation updateUserSettings($input: UpdateUserSettingsInput!) {
    updateUserSettings(updateUserSettingsInput: $input) {
      success
      error
      user {
        id
        firstName
        lastName
        email
        phoneNumber
        isActive
        emailNotifications
        mobilePushNotifications
        timezone
        timezoneDisplayPreference
        userGroups {
          id
          name
          cognitoGroupName
          displayColour
        }
        tags {
          id
          name
          displayColour
          archived
        }
        brands {
          id
          name
          archived
        }
      }
    }
  }
`);
